import React from "react";
import { Button, Form, Icon, Input, message, Row, Col, Typography } from "antd";
import { connect } from "react-redux";
import { Link } from "react-router-dom";
import axios from 'axios';
import { API_PATH } from '../constants/ApiPath'
import "./signin.less"
import CircularProgress from "components/CircularProgress/index";

const FormItem = Form.Item;
const { Text, Title } = Typography;

class ForgotPassword extends React.Component {

  constructor(props) {
    super(props);
    this.state = {
    token : localStorage.getItem('token')?localStorage.getItem('token'):null,
    cloader:false
    };

  }

  handleSubmit = (e) => {
    e.preventDefault();
    this.props.form.validateFields((err, values) => {
      const hostName = window.location.protocol + '//' + window.location.host + '/reset-password';
      if (!err) {
        this.setState({ cloader: true });
        const user = {
          email: values.email,
          host: hostName
        };
        const headers = {
          'Content-Type': 'application/json',
          'Accept': 'application/json',
        };
        const endpoint = '/partner/password-reset/';
        axios.post(API_PATH.concat(endpoint), user, { headers })
          .then(res => {
            if (res['status'] === 200) {
              this.setState({ cloader: false });
              message.success(res.data['message']);
            } else {
              this.setState({ cloader: false });
              message.error(res.data['message']);
            }
          })
          .catch(error => {
            this.setState({ cloader: false });
            if (error.response && error.response.status === 401) {
              message.error(error.response.data['message'] || 'An error occurred');
            } else {
              message.error(error.toString());
            }
          });
      }
    });
  };



  render() {
    const { getFieldDecorator } = this.props.form;
    const { showMessage, alertMessage } = this.props;

    return (
      <div className="gx-app-login-wrap modern-signin-wrapper">
        <div className="gx-app-login-container modern-signin-container">
          <Row type="flex" align="middle" className="gx-app-login-main-content modern-signin-main" gutter={0}>
            <Col xl={12} lg={12} md={12} sm={24} xs={24} className="emptySpacing modern-signin-left">
              <div 
                className="modern-signin-left-bg"
                style={{ backgroundColor: '#FAFAFA' }}
              >
                <div className="modern-signin-left-content">
                  <div className="modern-signin-logo -mobile-logo">
                    <img src={require('assets/images/LogoUniserved.png')} alt='Logo' />
                  </div>
                  <h1 className="modern-signin-title">Matrix</h1>
                  <p className="modern-signin-subtitle">Field Services Management</p>
                  <img src={require('assets/images/Service_Technicians_at_Work.png')} alt='Graphic' className="modern-signin-graphic" />
                </div>
              </div>
            </Col>
            <Col xl={12} lg={12} md={12} sm={24} xs={24} className="emptySpacing modern-signin-right">
              <div className="modern-signin-form-container">
                <div className="modern-signin-header">
                  <div className="modern-signin-header-left">
                    <Title level={2} className="modern-signin-header-title">Matrix</Title>
                    <Text className="modern-signin-header-subtitle">Field Services Management</Text>
                  </div>
                  <div className="modern-signin-header-right">
                    <img src={require('assets/images/LogoUniserved.png')} alt='Logo' className="modern-signin-header-logo" />
                  </div>
                </div>
                <div className="modern-signin-form-content">
                  <Title level={1} className="modern-signin-form-title" style={{ color: '#262626' }}>Forgot Password</Title>
                  <Text className="modern-signin-form-text">Please enter your registered email ID here and we will send the link to your email immediately.</Text>
                  <Form layout="vertical" onSubmit={this.handleSubmit} className="modern-signin-form" autoComplete="off">
                    <FormItem
                      label="* Your email address:"
                      className="modern-signin-form-item"
                      required={false}
                    >
                      {getFieldDecorator('email', {
                        initialValue: "",
                        rules: [{
                          required: true, type: 'email', message: 'The input is not valid E-mail!',
                        }],
                      })(
                        <Input placeholder="Enter your email here..." className="modern-signin-input" autoComplete="off" name="email-disabled" />
                      )}
                    </FormItem>
                    <FormItem className="modern-signin-submit-item">
                      <div className="modern-signin-submit-wrapper">
                        <Button type="primary" className="modern-signin-submit-btn" htmlType="submit">
                          <Icon type="mail" /> Send Reset Link
                        </Button>
                        <div className="modern-signin-account-link-wrapper">
                          <span className="modern-signin-account-text">Remember your password?</span>
                          <Link to="/signin" className="modern-signin-account-link">Sign in</Link>
                        </div>
                      </div>
                    </FormItem>
                  </Form>
                </div>
              </div>
              {this.state.cloader ?
                <div className="gx-loader-view">
                  <CircularProgress />
                </div> : null}
              {showMessage ?
                message.error(alertMessage.toString()) : null}
            </Col>
          </Row>
        </div>
      </div>
    );
  }
}

const WrappedNormalLoginForm = Form.create()(ForgotPassword);

const mapStateToProps = ({ auth }) => {
  const { alertMessage, showMessage } = auth;
  return { alertMessage, showMessage };
};

export default connect(mapStateToProps,)(WrappedNormalLoginForm);
